import { render, staticRenderFns } from "./DtOcorrenciasTransito.vue?vue&type=template&id=e975562a"
import script from "./DtOcorrenciasTransito.vue?vue&type=script&lang=js"
export * from "./DtOcorrenciasTransito.vue?vue&type=script&lang=js"
import style0 from "./DtOcorrenciasTransito.vue?vue&type=style&index=0&id=e975562a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports